import React  from 'react';
import PropTypes from 'prop-types';

import SelectProgress from "core/gd-ui/select-progress/common";

export default function ProgressBarInList(props) {

    return (
        <SelectProgress renderValue="bar-50"
                        className={props.className}
                        notSetPlaceholder="Progress"
                        underlined="on-hover"
                        value={props.item.progress}
                        attachment="center right"
                        targetAttachment="center left"
                        offset="0 0"
                        disabled={props.disabled}
                        onUserSelect={props.onProgressSelect}
                        deleteButton={true} />
    );
}

ProgressBarInList.propTypes = {
    item: PropTypes.object,

    onProgressSelect: PropTypes.func
};